import React from 'react';
import { HqoClientSdk } from '@hqo/hqo-miniapp-client-sdk';

export const MiniappSdkContext = React.createContext<null | HqoClientSdk>(null);
